/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    CashRegisterModelsListDto,
    CashRegistersModelsListFilterParams,
} from '../api/cashRegisterModels/cashRegisterModelsClient.typings';
import { Order, PageQueryParams, SortQueryParams } from '../api/apiCommon.typings';
import { CashRegisterModelsActionType, CashRegisterModelsAction } from '../actions/cashRegisterModelsActions';
import { CashRegisterModelsListTableData } from '../../components/RegistryWidgets/CashRegisterModels/CashRegisterModelsList/CashRegisterModelsListConfig';

export const rowsPerPage = [20, 30, 40];
export const defaultSortingKey: keyof CashRegisterModelsListTableData = 'name';
export const defaultSortingOrder: Order = 'asc';
export const defaultSearchType: keyof CashRegisterModelsListTableData = 'name';
export const defaultPaginationLimit = rowsPerPage[0];
export const defaultAgentFilter: boolean = null;
export const defaultPortableFilter: boolean = null;
const HIDE_SORTING = true;

export interface CashRegisterModelsState {
    cashRegisterModelsList: CashRegisterModelsListDto;
    pageParams: PageQueryParams;
    sortParams: SortQueryParams;
    filterParams: CashRegistersModelsListFilterParams;
    changedFilterParams: CashRegistersModelsListFilterParams;
    isLoading: boolean;
}

const initialState: CashRegisterModelsState = {
    cashRegisterModelsList: {
        count: 0,
        cashRegisterModels: [],
    },
    pageParams: {
        limit: defaultPaginationLimit,
        offset: 0,
    },
    sortParams: {
        sort: HIDE_SORTING ? '' : `${defaultSortingKey},${defaultSortingOrder}`,
    },
    filterParams: {
        search_type: defaultSearchType,
        search_text: '',
        status: [],
        operatorTaxNumber: [],
        agent: defaultAgentFilter,
        portable: defaultPortableFilter,
    },
    changedFilterParams: null,
    isLoading: false,
};

export function cashRegisterModelsReducer(
    state: CashRegisterModelsState = initialState,
    action: CashRegisterModelsAction,
): CashRegisterModelsState {
    switch (action.type) {
        case CashRegisterModelsActionType.OPEN_REGISTRY_CASH_REGISTER_MODELS_LIST_PAGE:
            return {
                ...state,
                isLoading: true,
            };

        case CashRegisterModelsActionType.APPLY_PAGING:
            return {
                ...state,
                isLoading: true,
                pageParams: action.payload,
                changedFilterParams: null,
            };

        case CashRegisterModelsActionType.APPLY_FILTERS:
            return {
                ...state,
                isLoading: true,
                pageParams: { ...state.pageParams, offset: 0 },
                filterParams: state.changedFilterParams ? { ...state.changedFilterParams } : { ...state.filterParams },
                changedFilterParams: null,
            };

        case CashRegisterModelsActionType.APPLY_SORTING:
            return {
                ...state,
                isLoading: true,
                sortParams: action.payload,
                changedFilterParams: null,
            };

        case CashRegisterModelsActionType.CHANGE_FILTERS:
            return {
                ...state,
                changedFilterParams: action.payload,
            };

        case CashRegisterModelsActionType.FETCH_CASH_REGISTER_MODELS_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                cashRegisterModelsList: action.payload.list,
            };

        case CashRegisterModelsActionType.FETCH_CASH_REGISTER_MODELS_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
                cashRegisterModelsList: {
                    count: 0,
                    cashRegisterModels: [],
                },
            };

        case CashRegisterModelsActionType.DOWNLOAD_EXCEL:
            return {
                ...state,
                isLoading: true,
                changedFilterParams: null,
            };

        case CashRegisterModelsActionType.DOWNLOAD_EXCEL_SUCCESS:
        case CashRegisterModelsActionType.DOWNLOAD_EXCEL_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case CashRegisterModelsActionType.EXIT_REGISTRY_CASH_REGISTER_MODELS_LIST_PAGE:
            return {
                ...state,
                cashRegisterModelsList: {
                    count: 0,
                    cashRegisterModels: [],
                },
                changedFilterParams: null,
            };

        default:
            return state;
    }
}
